/**
 * 轻量 i18n（不依赖 vue-i18n）
 * 全站仅一个页面，字典 + translate() 足够；配合 mixin 中的 locale 响应式状态实现即时切换
 */
import zh from './locales/zh';
import en from './locales/en';

const messages = { zh, en };

export const SUPPORTED_LOCALES = ['zh', 'en'];
export const DEFAULT_LOCALE = 'zh';
export const STORAGE_KEY = 'tek-locale';

export function getMessages(locale) {
  return messages[locale] || messages[DEFAULT_LOCALE];
}

/**
 * 翻译：支持点号嵌套 key 与 {param} 参数插值
 * translate('zh', 'search.found', { count: 5 }) -> '为您找到 5 个相关文件：'
 */
export function translate(locale, key, params) {
  const dict = getMessages(locale);
  const value = key.split('.').reduce((obj, k) => (obj == null ? obj : obj[k]), dict);
  if (value == null) return key;
  if (params) {
    return value.replace(/\{(\w+)\}/g, (match, k) =>
      params[k] != null ? String(params[k]) : match
    );
  }
  return value;
}
